import { i18n } from '~/utils';

export const DLN_SOURCES = {
  AI_OUTPUT: {
    KEY: 'ai_output',
    LABEL: i18n.t(($) => $.dlnSources.aiOutput, { ns: 'delivery' }),
  },
  API_INTEGRATION: {
    KEY: 'api_integration',
    LABEL: i18n.t(($) => $.dlnSources.apiIntegration, { ns: 'delivery' }),
  },
  API_POLLER: {
    KEY: 'api_poller',
    LABEL: i18n.t(($) => $.dlnSources.apiPoller, { ns: 'delivery' }),
  },
  DEMO_DLN: {
    KEY: 'demo_dln',
    LABEL: i18n.t(($) => $.dlnSources.demoDln, { ns: 'delivery' }),
  },
  EMAIL: {
    KEY: 'email',
    LABEL: i18n.t(($) => $.dlnSources.email, { ns: 'delivery' }),
  },
  EMAIL_SCAN: {
    KEY: 'email_scan',
    LABEL: i18n.t(($) => $.dlnSources.emailScan, { ns: 'delivery' }),
  },
  FTP: {
    KEY: 'ftp',
    LABEL: i18n.t(($) => $.dlnSources.ftp, { ns: 'delivery' }),
  },
  LEGACY: {
    KEY: 'legacy',
    LABEL: i18n.t(($) => $.dlnSources.legacy, { ns: 'delivery' }),
  },
  MOBILE_OCR: {
    KEY: 'mobile_ocr',
    LABEL: i18n.t(($) => $.dlnSources.mobileOcr, { ns: 'delivery' }),
  },
  MOBILE_OCR_FAST: {
    KEY: 'mobile_ocr_fast',
    LABEL: i18n.t(($) => $.dlnSources.mobileOcrFast, { ns: 'delivery' }),
  },
  MOBILE_OCR_VALIDATED: {
    KEY: 'mobile_ocr_validated',
    LABEL: i18n.t(($) => $.dlnSources.mobileOcrValidated, {
      ns: 'delivery',
    }),
  },
  MOBILE_QR: {
    KEY: 'mobile_qr',
    LABEL: i18n.t(($) => $.dlnSources.mobileQr, { ns: 'delivery' }),
  },
  REPARSING: {
    KEY: 'reparsing',
    LABEL: i18n.t(($) => $.dlnSources.reparsing, { ns: 'delivery' }),
  },
  UNKNOWN: {
    KEY: 'unknown',
    LABEL: i18n.t(($) => $.dlnSources.unknown, { ns: 'delivery' }),
  },
  WEB_UPLOAD: {
    KEY: 'web_upload',
    LABEL: i18n.t(($) => $.dlnSources.webUpload, { ns: 'delivery' }),
  },
} as const;

export type DLN_SOURCE_KEYS =
  (typeof DLN_SOURCES)[keyof typeof DLN_SOURCES]['KEY'];

export const getSourceLabelByKey = (key: DLN_SOURCE_KEYS) => {
  const source = Object.values(DLN_SOURCES).find(
    (source) => source.KEY === key,
  );
  return source?.LABEL ?? DLN_SOURCES.UNKNOWN.LABEL;
};
